import React, { useState, useEffect} from "react";
import UspItems from './UspItems';
import { get, post } from '../../util/axiosConfig/AxiosConfig'
import Loader from '../../util/preloader/Preloader';
import CourseRequestItems from "./CourseRequestItems";

const CourseRequest = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // fetchData();
        // sendData();
    }, []);

    const fetchData = async () => {
            try {
                setLoading(true);
                const response = await get('/posts/');
                console.log(response);
            } catch (error) {
                setLoading(false);
                console.error(error);
            } finally {
                setLoading(false);
            }
        };


    const sendData = async () => {
        const data = {
            "userId": 1,
            "id": 1,
            "title": "sunt aut facere repellat provident occaecati excepturi optio reprehenderit",
            "body": "quia et suscipit\nsuscipit recusandae consequuntur expedita et cum\nreprehenderit molestiae ut ut quas totam\nnostrum rerum est autem sunt rem eveniet architecto"
        };

        try {
            const response = await post('/posts', data);
            setLoading(true);
            console.log(response);
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    };

    return (
        <React.Fragment>
        
            <div className="courseRequest_sec_main_title">
                {/* <h2 className="usp_sec_title">Course Request</h2> */}
            
            <div className="courseRequest_main">
                <div className="container">
                <CourseRequestItems/>
                    
                </div>
            </div>
            </div>
        </React.Fragment>
    )
}

export default CourseRequest;